<template>
  <div>
    <div class="title">基本信息</div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
      <FormItem label="昵称" prop="nickname">
        <Input v-model="formValidate.nickname" placeholder="请输入昵称，最多不超多10个字" style="width: 300px;" clearable></Input>
        <span>0/10</span>
      </FormItem>
      <FormItem label="手机号" prop="mobile">
        <Input v-model="formValidate.mobile" placeholder="请输入手机号" style="width: 300px;" clearable></Input>
      </FormItem>
      <FormItem label="登录密码">
        <Input style="width: 300px;" v-model="formValidate.password" clearable></Input>
      </FormItem>
      <FormItem label="角色" prop="role_id">
        <Select v-model="formValidate.role_id" placeholder="请选择" style="width: 300px;" clearable>
          <Option
            v-for="(item,index) in roleList"
            :key="index"
            :value="item.role_id"
          >{{item.role_name}}</Option>
        </Select>
      </FormItem>
      <Divider />
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'SettingAccount'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submits('formValidate')"
        >保存并返回</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: "addAccount",
  data() {
    // 手机
    const validataPhone = (rule, value, callback) => {
      let reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!reg.test(value)) {
        callback(new Error("手机格式不正确"));
      } else {
        callback();
      }
    };
    return {
      type: this.$route.query.type,
      id: this.$route.query.id || "",
      formValidate: {
        nickname: "",
        mobile: "",
        password: "",
        role_id: ""
      },
      ruleValidate: {
        nickname: [
          { required: true, message: "用户昵称不能为空！", trigger: "blur" }
        ],
        mobile: [{ required: true, validator: validataPhone, trigger: "blur" }],
        password: [
          { required: true, message: "密码不能为空！", trigger: "blur" }
        ],
        role_id: [{ required: true, message: "角色不能为空" }]
      },
      roleList: []
    };
  },
  async created() {
    await this.getRoleList();
    await this.getData();
  },
  methods: {
    async getRoleList() {
      let data = await this.$http.get("/api/role", { limit: 100 });
      this.roleList = data.list;
    },
    async getData() {
      if (!this.id) {
        return;
      }
      let data = await this.$http.get(`/api/adminUser/${this.id}`);
      this.formValidate.nickname = data.nickname;
      this.formValidate.mobile = data.mobile;
      this.formValidate.password = data.password || "";
      this.formValidate.password = data.password || "";
      this.formValidate.role_id = data.user_role.role_id;
    },
    submits(name) {
      this.$refs[name].validate(async valid => {
        if (!valid) {
          return;
        }
        let obj = {
          nickname: this.formValidate.nickname,
          mobile: this.formValidate.mobile,
          password: this.formValidate.password,
          role_id: this.formValidate.role_id
        };
        if (this.id) {
          obj.id = this.id;
        }
        if (this.id) {
          await this.$http.put(`/api/adminUser/${this.id}`, obj);
        } else {
          await this.$http.post("/api/adminUser", obj);
        }
        this.$Message.saveSuccess();
        this.formValidate = {
          nickname: "",
          mobile: "",
          password: "",
          role_id: ""
        };
        this.$router.push({
          name: "SettingAccount"
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>